import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Svg } from "../svg/Svg";
export const ArrowRightIcon = forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "ArrowRightIcon", ...props, ref: ref, children: _jsx("g", { children: _jsx("polyline", { fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeWidth: props.strokeWidth, points: "7 4 11 8 7 12" }) }) })));
ArrowRightIcon.displayName = "ArrowRightIcon";
